import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PriorApprovalsService {

  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getPriorApprovalsType() {
    return this.http.get<any[]>(environment.serviceURL + environment.getPriorApprovalsType);
  }

  getPriorApprovalsInformation(agreementId: any, agreementYear: string ) {
    let param = new HttpParams();
    let url = '';
    if (agreementYear !== null) {
      param = param.append('agreementYear', agreementYear);
    }
    url = environment.serviceURL + environment.getPriorApprovalsInformation + agreementId;
    return this.http.get<any>(url, { params: param });
  }

  savePriorApprovalsInformation(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.savePriorApprovalsInformation, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deletePriorApprovals(delDeliverableIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDeliverableIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deletePriorApprovals, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete deliverable')));
  }
}
